/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";
import RcTable from "rc-table";
import { ColumnsType } from "rc-table/lib/interface";
import { TableProps } from "rc-table/lib/Table";
import styles from "./Table.module.scss";

export type ITableProps<T> = TableProps<T>;

export type ITableColumnProps<T> = ColumnsType<T>;

export const Table = <T extends Record<string, any>>(props: ITableProps<T>) => {
  return <RcTable prefixCls="Table" {...props} />;
};

export default Table;
